<template>
  <v-dialog v-model="showModal" max-width="500px" persistent>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>{{title}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container  grid-list-xl>
          <v-layout row wrap>
            <v-flex xs6>
              <DatePicker v-model="openDayData.start" pickerLabel="Data początkowa" :required="true" :readonly="false"></DatePicker>
            </v-flex>
            <v-flex xs6>
              <DatePicker v-model="openDayData.end" pickerLabel="Data końcowa" :required="true" :readonly="false"></DatePicker>
            </v-flex>
            <v-flex xs6>
              <TimePicker v-model="openDayData.timeStart" text="Początek"></TimePicker>
            </v-flex>
            <v-flex xs6>
              <TimePicker v-model="openDayData.timeEnd" text="Koniec"></TimePicker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm" color="error">Zamknij</v-btn>
        <v-btn color="success" @click="handleSubmit">Zapisz</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TimePicker from "@/components/shared/TimePicker"
import { therapistsService } from "@/services/";
import swal from "sweetalert";
import DatePicker from "@/components/shared/DatePicker.vue";
export default {
  name: 'AddEditAdditionalDay',
  data () {
    return {
      title: 'Dodawanie dodatkowego dnia otwartego'
    }
  },
  props: {
    visible: Boolean,
    openDayData: Object,
    therapistID: Number
  },
  computed: {
    showModal: {
      get: function() {
        if(!this.visible)
        {
          this.clearFormData()
          this.errors.clear();
        }
        return this.visible
      },
      set: function(value) {
        if(!value){
          this.$emit('close')
        }

      }
    }
  },

  watch: {
    visible: function(newv)
    {
      if(newv)
      {
        if(this.openDayData.id == 0)
        {
          this.clearFormData()
          this.title = 'Dodawanie dodatkowego dnia otwartego'
        }
        else
        {
          this.title = 'Edycja dodatkowego dnia otwartego'
        }
      }
    }
  },
  methods: {
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    updateFormData() {

    },
    clearFormData() {

    },
    closeForm() {
      this.$emit("close");
      this.clearFormData()
    },
    saveNewAdditionalDay() {
      if(!this.openDayData.timeStart)
      {
        this.showError(false,'Proszę podać godzinę początkową.')
        return;
      }
      if(!this.openDayData.timeEnd)
      {
        this.showError(false,'Proszę podać godzinę końcową.')
        return;
      }
      if(!this.openDayData.start)
      {
        this.showError(false,'Proszę podać datę początkowa.')
        return;
      }
      if(!this.openDayData.end)
      {
        this.showError(false,'Proszę podać datę końcową.')
        return;
      }
      therapistsService.AddAdditionalOpenDay({
        timeStart: this.openDayData.timeStart,
        timeEnd: this.openDayData.timeEnd,
        start: this.openDayData.start,
        end: this.openDayData.end,
        therapistID: this.therapistID
      }).then(()=> {
        this.$emit('close')
      }).catch(e=> {
        if(e.response != null && e.response.data != null && e.response.data.error != null)
        {
          this.showError(false,e.response.data.error.message)
        }
        else
        {
          this.showError(false, 'Błąd zapisu dodatkowego dnia otwartego.')
        }
      })

    },
    updateAdditionalDay() {

      therapistsService.UpdateAdditionalOpenDay({
        timeStart: this.openDayData.timeStart,
        timeEnd: this.openDayData.timeEnd,
        start: this.openDayData.start,
        end: this.openDayData.end,
        id: this.openDayData.id
      }).then(()=> {
        this.$emit('close')
      }).catch(e=> {
        if(e.response != null && e.response.data != null && e.response.data.error != null)
        {
          this.showError(false,e.response.data.error.message)
        }
        else
        {
          this.showError(false, 'Błąd zapisu dodatkowego dnia otwartego.')
        }
      })


    },
    handleSubmit() {
      if(this.openDayData.id == 0)
      {
        this.saveNewAdditionalDay()
      }
      else
      {
        this.updateAdditionalDay()
      }
    }
  },
  components: {
    DatePicker,
    TimePicker
  }
}
</script>

<style>

</style>
